import { CommonResponse } from "@gtpl/shared-models/masters";
import connection from "./connection";
import { EnquiryAssessmentUpdateReq, CostingSheetResponse, EnquiryIdreq, QuoteRequest, getAllEnquiryInfoReq, ConfirmedContainersReq, ContainersReq, CostingDestinationReq } from "@gtpl/shared-models/enquiry-management";
import axios from "axios";

export class CostingService {
    URL = connection.DEPLOY_URL + '/costSheet';

  async getQuotationSentEnquiries(request: getAllEnquiryInfoReq): Promise<CommonResponse> {
      return await axios.post(this.URL + '/getQuotationSentEnquiries', request)
          .then(res => {
              return res.data
          })
  }
  async getEnquiryNo(request: getAllEnquiryInfoReq): Promise<CommonResponse> {
      return await axios.post(this.URL + '/getEnquiryNo', request)
          .then(res => {
              return res.data
          })
  }
  async UpdateEnquiry(req:QuoteRequest): Promise<CommonResponse> {
    return await axios.post(this.URL + '/UpdateEnquiry',req)
      .then(res => {
        return res.data
      })
  }

  async UpdateBuyerWisePrices(req:QuoteRequest): Promise<CommonResponse> {
    return await axios.post(this.URL + '/UpdateBuyerWisePrices',req)
      .then(res => {
        return res.data
      })
  }


  async generateCostSheet(req:EnquiryIdreq): Promise<CostingSheetResponse> {
    return await axios.post(this.URL + '/generateCostSheet',req)
      .then(res => {
        return res.data
      })
  }
  async UpdateCostingApproval(req:EnquiryAssessmentUpdateReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/UpdateCostingApproval',req)
      .then(res => {
        return res.data
      })
  }

  async getCostSheetInfo(req:EnquiryIdreq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getCostSheetInfo',req)
      .then(res => {
        return res.data
      })
  }

  async getEnquiryDestinations(request: getAllEnquiryInfoReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getEnquiryDestinations', request)
        .then(res => {
            return res.data
        })
  }
  async getEnquiryUnits(request: getAllEnquiryInfoReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getEnquiryUnits', request)
        .then(res => {
            return res.data
        })
  }

  async updateConfirmedContainers(request: ContainersReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/updateConfirmedContainers', request)
        .then(res => {
            return res.data
        })
  }

  async getDestinationsForCostSheet(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getDestinationsForCostSheet')
        .then(res => {
            return res.data
        })
  }

  async generateCostSheetAgainstDestination(req:CostingDestinationReq): Promise<CostingSheetResponse> {
    return await axios.post(this.URL + '/generateCostSheetAgainstDestination',req)
      .then(res => {
        return res.data
      })
  }

  async getCostSheetInfoForDestination(req:CostingDestinationReq): Promise<CostingSheetResponse> {
    return await axios.post(this.URL + '/getCostSheetInfoForDestination',req)
      .then(res => {
        return res.data
      })
  }
}